import LISTE_CONFRERE from '@/i18n/fr/commun/confrere/confrere';
import * as produitsAchat from '@/i18n/fr/parametrage/produitsAchat';
import * as face from '@/i18n/fr/catalogue/produitFace';
import LISTE_PRODUIT_ECRAN from '@/i18n/fr/catalogue/produitEcran';
import * as pageGeneralInformation from '@/i18n/fr/pageGeneral';
import LISTE_PRODUITS_ACHAT_LOC from '@/i18n/fr/baux/produitAchatLoc/produitsAchatLoc';
import LISTE_PRODUITS_NON_COMMERCIALISABLE from '@/i18n/fr/catalogue/produitNonCommercialisable';
import LISTE_PRODUIT_RESEAU_TEMPO from '@/i18n/fr/catalogue/produitReseauTempo';
import * as reseauTempoDispo from '@/i18n/fr/outils/reseauTempo';
import CONNEXION from '@/i18n/fr/connexion/connexion';
import * as compteAnalytique from '@/i18n/fr/parametrage/compteAnalytique';
import POP_UP_AFFECTATION_FACE from '@/i18n/fr/general/affectation';
import * as delaiReglement from '@/i18n/fr/parametrage/delaiReglement';
import LISTE_RELANCE_OPTION from '@/i18n/fr/relanceOption/relanceOption';
import LISTE_DEMANDE from '@/i18n/fr/bodac/demandeTempo/demandeTempo';
import * as typeTaxationTlpe from '@/i18n/fr/parametrage/typeTaxationTlpe';
import GENERAL_DCF from '@/i18n/fr/devisCommandeFacture/dcf';
import * as tiers from '@/i18n/fr/commun/tiers/tiers';
import ADD_PRODUIT_ASSOCIES from '@/i18n/fr/bodac/produit/produit';
import { PRODUIT_PRESSE, AJOUT_PRESSE_DCF } from '@/i18n/fr/catalogue/produitPresse';
import * as parametrageInterne from '@/i18n/fr/configInterne/parametresInterne';
import * as lignesCommande from '@/i18n/fr/bodac/lignesCommande/lignesCommande';
import LISTE_LIGNES_DEVIS from '@/i18n/fr/bodac/lignesDevis/lignesDevis';
import LIGNES_FACTURE from '@/i18n/fr/bodac/lignesFacture/lignesFacture';
import INDEXATION from '@/i18n/fr/parametrage/indexation';
import * as typeContact from '@/i18n/fr/parametrage/typeContact';
import AJOUT_SPONSORING_DCF from '@/i18n/fr/catalogue/produitSponsoring';
import AJOUT_AUTRE_DCF from '@/i18n/fr/catalogue/produitAutre';
import * as produitReseauMairie from '@/i18n/fr/catalogue/produitReseauMairie';
import * as accessoire from '@/i18n/fr/parametrage/accessoire';
import { AJOUT_PRODUIT_SALON, AJOUT_SALON_DCF } from '@/i18n/fr/catalogue/produitSalon';
import LISTE_FOURNISSEUR_MATERIEL from '@/i18n/fr/gabed/fournisseurMateriel/fournisseurMateriel';
import LISTE_RETROCESSION from '@/i18n/fr/bodac/retrocession/retrocesssion';
import * as indiceEtValeur from '@/i18n/fr/parametrage/indiceEtValeur';
import JSONEditor from '@/i18n/fr/JSONEditor/JSONEditor';
import importDonneIdelia from '@/i18n/fr/bodac/import/importIdelia';
import LISTE_PRODUIT_RESEAU_NUMERIQUE from '@/i18n/fr/catalogue/produitReseauNumerique';
import SPRINT from '@/i18n/fr/parametrage/sprint';
import * as formatAffiche from '@/i18n/fr/bodac/formatAffiche/formatAffiche';
import * as service from '@/i18n/fr/parametrage/service';
import * as regimeTva from './parametrage/regimeTva';
import * as devis from './devisCommande/devis';
import * as commande from './devisCommande/commande';
import * as produitUnitaires from './catalogue/produitUnitaires';
import * as sidebar from './sidebar';
import * as contacts from './clients/contacts';
import * as clients from './clients/clients';
import * as general from './general/general';
import * as address from './general/address';
import * as attachment from './general/attachment';
import * as validation from './general/validation';
import * as remise from './devisCommande/remise';
import * as echeancesCommandes from './devisCommande/echeancesCommandes';
import * as remiseBancaire from './remiseBancaire/remiseBancaire';
import * as journalReglements from './journalReglements/journalReglements';
import * as journalPaiements from './journalPaiements/journalPaiements';
import * as detail from './devisCommande/detail';
import * as ligneRegroupementPersonnalisee from './devisCommande/ligneRegroupementPersonnalisee';
import * as facture from './facture/facture';
import * as ecritureComptable from './ecritureComptable/ecritureComptable';
import * as catalogue from './catalogue/catalogue';
import * as produitsModulePresse from './catalogue/produitsModulePresse';
import * as acompte from './devisCommande/acompte';
import * as utilisateur from './parametrage/utilisateurs';
import * as parametrage from './parametrage/parametrage';
import MAIL from './general/mail';
import * as relance from './relances/relance';
import * as societes from './parametrage/societes';
import * as miseAJourTarif from './devisCommande/miseAJourTarif';
import * as miseAJourTva from './devisCommande/miseAJourTva';
import * as modifierDates from './devisCommande/modifierDates';
import * as domiciliationBancaire from './parametrage/domiciliationBancaire';
import ADD_AGENCE from './parametrage/agence';
import * as exerciceComptable from './compta/exerciceComptable/exerciceComptable';
import * as modeReglement from './parametrage/modeReglement';
import RESEAU_TEMPO from './disponibilite/planningReseauTempo';
import * as schemaComptable from './parametrage/schemaComptable';
import schemaComptableComponent from './general/schemaComptableComponent';
import DETAIL_PLANNING_NUMERIQUE from './disponibilite/planningNumerique';
import DETAIL_PLANNING_FACE_UNITAIRE from './disponibilite/planningFaceUnitaire';
import LISTE_NATURE_RODUIT from './parametrage/natureProduit';
import * as journalEcriture from './compta/journalEcriture/journalEcriture';
import * as lotsComptable from './compta/lotsComptable/lotsComptable';
import * as operationDiverse from './compta/operationDiverse/operationDiverse';
import * as importExportExcel from './devisCommande/importExportExcel';
import AJOUT_RESEAU_LC from './disponibilite/ajoutReseauLc';
import DETAIL_PLANNING_RESEAU_LC from './disponibilite/detailPlanningReseauLc';
import TABLE from './general/table';
import * as commentaire from './parametrage/commentaire';
import * as remiseLibelle from './parametrage/libelleRemise';
import OPTION_BLOCAGE from './devisCommande/optionBlocage';
import PREVISUALISATION from './devisCommandeFacture/previsualisation';
import * as contratNature from './parametrage/contratNature';
import * as civilite from './parametrage/civilite';
import * as dispositifType from './parametrage/dispositifType';
import * as materielFormat from './parametrage/materielFormat';
import * as materieltype from './parametrage/materielType';
import * as parametrageEdition from './parametrage/parametrageEdition';
import * as fournisseur from './commun/fournisseur/fournisseur';
import MOUVEMENT_CLIENT_PIECE from './bodac/mouvementClient';
import INFORMATIONS_GENERATION_CODE from './general/informationsGenerationCode';
import LISTE_COMMANDE_A_FACTURER from './commandeAFacturer/commandeAFacturer';
import LEVEL_BLOCAGE from './clients/levelBlocage';
import LISTE_ECHEANCES_A_PAYER_FACTURE from './echeancePaiement/echeancePaiement';
import * as regroupementProduit from './catalogue/regroupementProduit';
import LISTE_FACTOR from './factor/factor';
import LISTE_TRANSMISSION from './factor/transmission';
import LISTE_ECRITURE_COMPTABLE from './compta/ecritureComptable/ecritureComptable';
import CARTOGRAPHIE from './bodac/cartographie/cartographie';
import {
  IMPORT_CLIENTS, IMPORT_COMMANDES, IMPORT_CONTACTS,
  IMPORT_CAMPAGNES, IMPORT_CONTACTS_TIERS, IMPORT_DEMANDES_IMPRESSION,
  IMPORT_BON_STOCK,
  IMPORT_LOGO_DISPOSITIF,
  IMPORT_COMMANDES_GENERALE,
} from './importation/importation';
import SIGNATURE_ELECTRONIQUE from './parametrage/signatureElectronique';
import * as tag from './parametrage/tag';
import LISTE_SIGNATURE_ELECTRONIQUE_ENCOURS from './commun/signatureElectroniqueEncours/signatureElectroniqueEncours';
import * as campagne from './campagne/campagne';
import * as nomenclatureType from './parametrage/nomenclatureType';
import { ADD_PLAN_MEDIA, LISTE_PLAN_MEDIA, DETAIL_PLAN_MEDIA } from './planMedia/planMedia';
import * as bonStock from './bonStock/bonStock';
import LISTE_DEMANDE_IMPRESSION from './demandeImpression/listeDemandeImpression';
import EDITION_DEMANDE_IMPRESSION from './demandeImpression/editionDemandeImpression';
import DETAIL_DEMANDE_IMPRESSION from './demandeImpression/detailDemandeImpression';
import * as secteur from './parametrage/secteur';
import * as pays from './parametrage/pays';
import * as gestionMessage from './commun/gestionMessage/gestionMessage';
import { BESOIN } from './devisCommande/besoin';

// eslint-disable-next-line import/prefer-default-export
export const PAGES = {
  societes: societes.SOCIETES,
  detailUtilisateur: utilisateur.DETAIL_UTILISATEUR,
  supprimerRemiseBancaire: remiseBancaire.SUPPRESSION,
  supprimerReglement: remiseBancaire.SUPPRESSION_REGLEMENT,
  annulerReglement: remiseBancaire.ANNULATION_REGLEMENT,
  validationRemiseBancaire: remiseBancaire.VALIDATION_REMISE_BANCAIRE,
  devalidationRemiseBancaire: remiseBancaire.DEVALIDATION_REMISE_BANCAIRE,
  remiseBancaire: remiseBancaire.REMISE,
  optionBlocage: OPTION_BLOCAGE,
  levelBlocage: LEVEL_BLOCAGE,
  listeDevis: devis.LISTE_DEVIS,
  ajoutDevis: devis.AJOUT_DEVIS,
  dateDevis: devis.DATE_DEVIS,
  detailPlanningReseauLc: DETAIL_PLANNING_RESEAU_LC,
  schemaComptableComponent: schemaComptableComponent,
  validationDevis: devis.VALIDATION,
  listeCommandes: commande.LISTE_COMMANDE,
  listeCommandeCommissions: commande.LIST_COMMANDE_COMMISSIONS,
  renouvellementCommande: commande.RENOUVELLEMENT_COMMANDE,
  commandeBaf: commande.COMMANDE_BAF,
  facturationCommande: commande.FACTURATION_COMMANDE,
  editionCommande: commande.EDITION_COMMANDE,
  validationCommande: commande.VALIDATION,
  editionFacture: facture.EDITION_FACTURE,
  echeancierPaiement: facture.ECHEANCIER_PAIEMENT,
  validationFacture: facture.VALIDATION,
  validationAvoir: facture.VALIDATION_AVOIR,
  listeFactures: facture.LISTE_FACTURE,
  ecritureCompta: ecritureComptable.ECRITURE_COMPTABLE,
  validationEcriture: ecritureComptable.VALIDATION_ECRITURE,
  parametrage: parametrage.PARAMETRAGE,
  role: parametrage.ROLE,
  mail: MAIL,
  reseauTempo: RESEAU_TEMPO,
  produitFace: catalogue.PRODUIT_FACE,
  produitSalon: AJOUT_PRODUIT_SALON,
  ajoutSalonDcf: AJOUT_SALON_DCF,
  ajoutPresseDcf: AJOUT_PRESSE_DCF,
  ajoutSponsoringDcf: AJOUT_SPONSORING_DCF,
  ajoutAutreDcf: AJOUT_AUTRE_DCF,
  produitPresse: PRODUIT_PRESSE,
  detailProduitSalon: catalogue.SALON,
  detailProduitSponsoring: catalogue.SPONSORING,
  detailProduitPresse: catalogue.PRESSE,
  detailProduitAutre: catalogue.AUTRE,
  ecranNumerique: catalogue.ECRAN_NUMERIQUE,
  selectionProduit: catalogue.SELECTION_PRODUITS,
  listeProduitUnitaire: produitUnitaires.LISTE_PRODUITS_UNITAIRES,
  ajoutProduitUnitaire: produitUnitaires.AJOUT_PRODUIT_UNITAIRE,
  popupAffectation: produitUnitaires.POPUP_AFFECTATION,
  sidebar: sidebar.SIDEBAR,
  listeContacts: contacts.LISTE_CONTACTS,
  detailContact: contacts.DETAIL_CONTACT,
  editionContact: contacts.EDITION_CONTACT,
  supprimerContact: contacts.SUPPRIMER_CONTACT,
  archiverContact: contacts.ARCHIVER_CONTACT,
  popupAjoutContactTiersFromParent: contacts.POPUP_AJOUT_CONTACT_TIERS_FROM_PARENT,
  listeClients: clients.LISTE_CLIENTS,
  detailClient: clients.DETAIL_CLIENT,
  editionClient: clients.EDITION_CLIENT,
  supprimerClient: clients.SUPPRIMER_CLIENT,
  archiverClient: clients.ARCHIVER_CLIENT,
  piecesJointes: attachment.PIECES_JOINTES,
  general: general.GENERAL,
  address: address.ADDRESS,
  validation: validation.VALIDATION,
  editionRemise: remise.EDITION_REMISE,
  supprimerCommande: commande.SUPPRESSION,
  supprimerDevis: devis.SUPPRESSION,
  supprimerFacture: facture.SUPPRESSION,
  detail: detail.DETAIL,
  relance: relance.RELANCE,
  addNewRelance: relance.ADD_NEW_RELANCE,
  gestionRole: parametrage.GESTION_ROLE,
  roleManager: parametrage.ROLE_MANAGER,
  catalogue: catalogue.CATALOGUE,
  listeProduitsModulePresse: produitsModulePresse.LISTE_PRODUITS_MODULE_PRESSE,
  detailProduitReseau: catalogue.DETAIL_PRODUIT_RESEAU,
  suppressionProduitReseau: catalogue.SUPPRESSION_PRODUIT_RESEAU,
  detailProduitReseauNumerique: catalogue.DETAIL_PRODUIT_RESEAU_NUMERIQUE,
  produitLocation: catalogue.PRODUIT_LOCATION,
  produitDivers: catalogue.PRODUIT_DIVERS,
  produitDispositif: catalogue.PRODUIT_DISPOSITIF,
  listeEcheances: echeancesCommandes.LISTE_ECHEANCES,
  listeCommandeAFacturer: LISTE_COMMANDE_A_FACTURER,
  date: echeancesCommandes.DATE,
  listeRegimeTva: regimeTva.LISTE_REGIME_TVA,
  editionRegimeTva: regimeTva.ADD_REGIME_TVA,
  facturation: echeancesCommandes.FACTURER,
  acompte: acompte.ACOMPTE,
  validationAcompte: acompte.VALIDATION_ACOMPTE,
  listeUtilisateur: utilisateur.LISTE_UTILISATEUR,
  thirdStepUtilisateur: utilisateur.UTILISATEUR_THIRD_STEP,
  secteurUtilisateur: utilisateur.SECTEUR_UTILISATEUR,
  createUtilisateur: utilisateur.CREATE_UTILISATEUR,
  firstStepUtilisateur: utilisateur.UTILISATEUR_FIRST_STEP,
  secondStepUtilisateur: utilisateur.UTILISATEUR_SECOND_STEP,
  serviceUtilisateur: utilisateur.SERVICE_UTILISATEUR,
  utilisateur: utilisateur.UTILISATEUR,
  validationUtilisateur: utilisateur.VALIDATION,
  relanceSave: relance.RELANCES_SAVE,
  detailSociete: societes.DETAIL,
  miseAJourTarif: miseAJourTarif.MAJ_PRIX_UNITAIRE,
  miseAJourTva: miseAJourTva.MAJ_TVA,
  modifierDates: modifierDates.MODIFIER_DATES,
  ligneRegroupementPersonnalisee: ligneRegroupementPersonnalisee.LIGNE_REGROUPEMENT_PERSONNALISEE,
  listeDomiciliationBancaire: domiciliationBancaire.LISTE_DOMICILIATION_BANCAIRE,
  addDomiciliationBancaire: domiciliationBancaire.ADD_DOMICILIATION_BANCAIRE,
  detailDomiciliationBancaire: domiciliationBancaire.DETAIL_DOMICILIATION_BANCAIRE,
  domiciliationBancairePositionCheque: domiciliationBancaire.POSITIONNEMENT_CHEQUE,
  addAgence: ADD_AGENCE,
  listeExerciceComptable: exerciceComptable.LISTE_EXERCICE_COMPTABLE,
  addExerciceComptable: exerciceComptable.ADD_EXERCICE_COMPTABLE,
  listeModeReglement: modeReglement.LISTE_MODE_REGLEMENT,
  addModeReglement: modeReglement.ADD_MODE_REGLEMENT,
  listeSchemaComptable: schemaComptable.LISTE_SCHEMA_COMPTABLE,
  addSchemaComptable: schemaComptable.ADD_SCHEMA_COMPTABLE,
  detailSchemaComptable: schemaComptable.DETAIL_SCHEMA_COMPTABLE,
  detailPlanningNumerique: DETAIL_PLANNING_NUMERIQUE,
  detailsPlanningFaceUnitaire: DETAIL_PLANNING_FACE_UNITAIRE,
  listeNatureProduit: LISTE_NATURE_RODUIT,
  listeJournalEcriture: journalEcriture.LISTE_JOURNAL_ECRITURE,
  popupEcritures: journalEcriture.POPUP_ECRITURES,
  listeLotsComptable: lotsComptable.LISTE_LOTS_COMPTABLE,
  listeDetailLotsComptable: lotsComptable.DETAIL_LOTS_COMPTABLE,
  supprimerLots: lotsComptable.SUPPRIMER_LOT,
  importExcel: importExportExcel.IMPORT_EXCEL,
  exportExcelReseauNum: importExportExcel.EXPORT_EXCEL_RESEAU_NUM,
  exportExcelFace: importExportExcel.EXPORT_EXCEL_FACE,
  exportExcelFaceSelect: importExportExcel.EXPORT_EXCEL_FACE_SELECT_IN_VENTE_TEMPO,
  exportExcelFaceSelectInReseauTempoForReseauPerso: importExportExcel
    .EXPORT_EXCEL_FACE_SELECT_IN_VENTE_TEMPO_FOR_RESEAU_PERSO,
  ajoutReseauLc: AJOUT_RESEAU_LC,
  detailFacture: facture.DETAIL_FACTURE,
  selectionEcheance: facture.SELECTION_ECHEANCE,
  listeFactureCommissions: facture.LIST_FACTURE_COMMISSIONS,
  table: TABLE,
  listeCommentaire: commentaire.LISTE_COMMENTAIRE,
  addEditCommentaire: commentaire.AJOUT_MODIFICATION_COMMENTAIRE,
  commentaire: commentaire.COMMENTAIRE,
  listeRemise: remiseLibelle.LISTE_REMISE,
  journalReglements: journalReglements.JOURNAL_REGLEMENT,
  journalPaiements: journalPaiements.JOURNAL_PAIEMENTS,
  addEditRemise: remiseLibelle.AJOUT_MODIFICATION_REMISE,
  remise: remiseLibelle.REMISE,
  detailCommande: commande.DETAIL_COMMANDE,
  previsualisation: PREVISUALISATION,
  detailDevis: devis.DETAIL_DEVIS,
  listeProduitAchat: produitsAchat.LISTE_PRODUITS_ACHAT,
  produitImpressionAffiche: produitsAchat.PRODUIT_IMPRESSION_AFFICHE,
  echeancierFacturation: commande.ECHEANCIER_FACTURATION,
  ecranAjoutFaces: face.ECRAN_AJOUT_FACES,
  listeContratNature: contratNature.LISTE_CONTRAT_NATURE,
  addEditContratNature: contratNature.ADD_CONTRAT_NATURE,
  pageGeneral: pageGeneralInformation.PAGE_GENERAL,
  pageGescom: pageGeneralInformation.PAGE_NAME_GESCOM,
  pageStock: pageGeneralInformation.PAGE_NAME_STOCK,
  pageLogistique: pageGeneralInformation.PAGE_NAME_LOGISTIQUE,
  pageCompta: pageGeneralInformation.PAGE_NAME_COMPTA,
  pagePatrimoine: pageGeneralInformation.PAGE_NAME_PATRIMOINE,
  pageParametrage: pageGeneralInformation.PAGE_NAME_PARAMETRAGE,
  pageMultiModule: pageGeneralInformation.PAGE_MULTI_MODULE,
  pageConfigInterne: pageGeneralInformation.PAGE_CONFIG_INTERNE,
  pageBaux: pageGeneralInformation.PAGE_NAME_BAUX,
  pagePresse: pageGeneralInformation.PAGE_NAME_PRESSE,
  pageAchat: pageGeneralInformation.PAGE_NAME_ACHAT,
  pageDemandeImpression: pageGeneralInformation.PAGE_DEMANDE_IPRESSION,
  addEditCivilite: civilite.ADD_CIVILITE,
  listeDispositifType: dispositifType.LISTE_DISPOSITIF_TYPE,
  addEditDispositifType: dispositifType.ADD_DISPOSITIF_TYPE,
  listeMaterielFormat: materielFormat.LISTE_MATERIEL_FORMAT,
  addEditMaterielFormat: materielFormat.ADD_MATERIEL_FORMAT,
  listeMaterielType: materieltype.LISTE_MATERIEL_TYPE,
  addEditMaterielType: materieltype.ADD_MATERIEL_TYPE,
  listeParametrageEdition: parametrageEdition.LISTE_PARAMETRAGE_EDITION,
  addEditParametrageEdition: parametrageEdition.ADD_PARAMETRAGE_EDITION,
  listeProduitAchatLoc: LISTE_PRODUITS_ACHAT_LOC,
  listeProduitNonCom: LISTE_PRODUITS_NON_COMMERCIALISABLE,
  listeProduitReseauTempo: LISTE_PRODUIT_RESEAU_TEMPO,
  listeProduitReseauNumerique: LISTE_PRODUIT_RESEAU_NUMERIQUE,
  listeVentesForClient: clients.LISTE_VENTES,
  connexion: CONNEXION,
  listeRelanceOption: LISTE_RELANCE_OPTION,
  addEditDelaiReglement: delaiReglement.ADD_DELAI_REGLEMENT,
  listeDelaiReglement: delaiReglement.LISTE_DELAI_REGLEMENT,
  listeProduitFace: face.LISTE_PRODUIT_FACE,
  popUpAffectationFace: POP_UP_AFFECTATION_FACE,
  listeProduitReseauTempoDispo: reseauTempoDispo.LISTE_PRODUIT_RESEAU_TEMPO_DISPO,
  popUpParametrageReseauTempoDispo: reseauTempoDispo.POP_UP_PARAMETRAGE_RESEAU_DISPO,
  listeDemandeTempo: LISTE_DEMANDE,
  addEditTypeTaxationTlpe: typeTaxationTlpe.ADD_TYPE_TAXATION_TLPE,
  listeTypeTaxationTlpe: typeTaxationTlpe.LISTE_TYPE_TAXATION_TLPE,
  modifRemiseBancaire: remiseBancaire.MODIF_REMISE_BANCAIRE,
  detailRemiseBancaire: remiseBancaire.DETAIL_REMISE_BANCAIRE,
  editionFournisseur: fournisseur.EDITION_FOURNISSEUR,
  detailFournisseur: fournisseur.DETAIL_FOURNISSEUR,
  fournisseur: fournisseur.FOURNISSEUR,
  listeConfrere: LISTE_CONFRERE,
  dcf: GENERAL_DCF,
  listeCompteAnalytique: compteAnalytique.LISTE_FACE_COMPTE_ANALYTIQUE,
  addEditCompteAnalytique: compteAnalytique.ADD_FACE_COMPTE_ANALYTIQUE,
  detailCatalogue: catalogue.DETAIL_CATALOGUE,
  paramInterneAdmin: parametrageInterne.PARAMETRES_INTERNE_ADMIN,
  paramInterne: parametrageInterne.PARAMETRES_INTERNE,
  configClient: parametrageInterne.PARAMETRES_INTERNE_CLIENT,
  importDonne: parametrageInterne.IMPOR_DATA,
  exportDonne: parametrageInterne.EXPOR_DATA,
  addEditTiers: tiers.ADD_EDIT_TIERS,
  detailTiers: tiers.DETAIL_TIERS,
  enCoursTiers: tiers.ENCOURS_TIERS,
  compteTiers: tiers.COMPTE_TIERS,
  exportBalanceTiers: tiers.EXPORT_BALANCE_TIERS,
  listeLignesDevis: LISTE_LIGNES_DEVIS,
  lignesCommandeManager: lignesCommande.LIGNES_COMMANDE_MANAGER,
  listeLignesCommande: lignesCommande.LISTE_LIGNES_COMMANDE,
  listeLignesCommandeARenouveler: lignesCommande.LISTE_LIGNES_COMMANDE_A_RENOUVELER,
  listeLignesFacture: LIGNES_FACTURE,
  informationsGenerationCode: INFORMATIONS_GENERATION_CODE,
  detailReseauMairie: produitReseauMairie.DETAIL_PRODUIT_RESEAU_MAIRIE,
  addReseauMairieInDcf: produitReseauMairie.AJOUT_RESEAU_MAIRIE_DCF,
  mouvementClientPiece: MOUVEMENT_CLIENT_PIECE,
  addProduitsAssocies: ADD_PRODUIT_ASSOCIES,
  indexation: INDEXATION,
  listeTypeContact: typeContact.LISTE,
  addEditTypeContact: typeContact.ADD,
  listeAccessoire: accessoire.ACCESSOIRE,
  addEditAccessoire: accessoire.ADD_EDIT_ACCESSOIRE,
  listeRelanceForClient: clients.RELANCES,
  listeEcheancePaiement: LISTE_ECHEANCES_A_PAYER_FACTURE,
  listeFournisseurMateriel: LISTE_FOURNISSEUR_MATERIEL,
  listeRetrocession: LISTE_RETROCESSION,
  listeRegroupementProduit: regroupementProduit.LISTE_REGROUPEMENT_PRODUIT,
  addEditRegroupementProduit: regroupementProduit.EDITION_REGROUPEMENT_PRODUIT,
  detailRegroupementProduit: regroupementProduit.DETAIL_REGROUPEMENT_PRODUIT,
  ajoutProduitSurRegroupement: regroupementProduit.AJOUT_PRODUIT_SUR_REGROUPEMENT,
  listeOperationDiverse: operationDiverse.LISTE_OPERATION_DIVERSE,
  addOperationDiverse: operationDiverse.ADD_OPERATION_DIVERSE,
  detailOperationDiverse: operationDiverse.DETAIL_OPERATION_DIVERSE,
  factor: LISTE_FACTOR,
  transmission: LISTE_TRANSMISSION,
  factorFacture: facture.FACTOR,
  listeEcritureComptable: LISTE_ECRITURE_COMPTABLE,
  cartographie: CARTOGRAPHIE,
  importationClient: IMPORT_CLIENTS,
  importationCommande: IMPORT_COMMANDES,
  importationCommandeGenerale: IMPORT_COMMANDES_GENERALE,
  signatureElectronique: SIGNATURE_ELECTRONIQUE,
  listeSignatureElectroniqueEncours: LISTE_SIGNATURE_ELECTRONIQUE_ENCOURS,
  addEditIndiceEtValeur: indiceEtValeur.ADD_INDICE,
  listeIndiceEtValeur: indiceEtValeur.LISTE_INDICE_ET_VALEUR,
  listeProduitEcran: LISTE_PRODUIT_ECRAN,
  listeTag: tag.LISTE_TAG,
  addEditTag: tag.ADD_TAG,
  listePays: pays.LISTE_PAYS,
  addEditPays: pays.ADD_PAYS,
  listeNomenclatureType: nomenclatureType.LISTE,
  addEditNomenclatureType: nomenclatureType.ADD,
  nomenclatureTechnique: nomenclatureType.NOMENCLATURE_TECHNIQUE,
  listeCampagnes: campagne.LISTE_CAMPAGNE,
  detailCampagne: campagne.DETAIL_CAMPAGNE,
  editionCampagne: campagne.EDITION_CAMPAGNE,
  importationContact: IMPORT_CONTACTS,
  importationContactsTiers: IMPORT_CONTACTS_TIERS,
  importationCampagne: IMPORT_CAMPAGNES,
  importationDemandeImpression: IMPORT_DEMANDES_IMPRESSION,
  JSONEditor: JSONEditor,
  addEditPlanMedia: ADD_PLAN_MEDIA,
  listePlanMedia: LISTE_PLAN_MEDIA,
  detailPlanMedia: DETAIL_PLAN_MEDIA,
  importDonneIdelia: importDonneIdelia,
  stock: bonStock.LISTE,
  validationBonStock: bonStock.VALIDATION,
  mouvementStock: bonStock.MouvementStock,
  listeDemandeImpression: LISTE_DEMANDE_IMPRESSION,
  editionDemandeImpression: EDITION_DEMANDE_IMPRESSION,
  detailDemandeImpression: DETAIL_DEMANDE_IMPRESSION,
  listeSecteur: secteur.LISTE_SECTEUR,
  addEditSecteur: secteur.EDITION_SECTEUR,
  addSecteurLien: secteur.SECTEUR_LIEN,
  importationBonStock: IMPORT_BON_STOCK,
  importationLogoDispositif: IMPORT_LOGO_DISPOSITIF,
  gestionMessage: gestionMessage.GESTION_MESSAGE,
  sprint: SPRINT,
  listeFormatAffiche: formatAffiche.LISTE_FORMAT_AFFICHE,
  editionFormatAffiche: formatAffiche.EDITION_FORMAT_AFFICHE,
  detailFormatAffiche: formatAffiche.DETAIL_FORMAT_AFFICHE,
  listeService: service.LISTE_SERVICE,
  editionService: service.EDITION_SERVICE,
  popupExtraitCompteTiers: tiers.EDITION_EXTRAIT_COMPTE_TIERS,
  besoin: BESOIN,
};
